// Types

export type RuntimeEnvConfig = {
    flags: {
        connectTebutoMeetEnabled: boolean
        connectZoomEnabled: boolean
        connectMicrosoftTeamsEnabled: boolean
        connectGoogleCalendarEnabled: boolean
        connectOutlookEnabled: boolean
        optionalClientDataEnabled: boolean
        secureMessagesEnabled: boolean
    }
    payPal: {
        clientId: string
    }
}

export type LoadedRuntimeEnvConfig = {
    flags: {
        connectTebutoMeetEnabled?: boolean
        connectZoomEnabled?: boolean
        connectMicrosoftTeamsEnabled?: boolean
        connectGoogleCalendarEnabled?: boolean
        connectOutlookEnabled?: boolean
        optionalClientDataEnabled?: boolean
        secureMessagesEnabled?: boolean
    }
    payPal: {
        clientId?: string
    }
}

// Constants

export const DEFAULT_ENV_VARIABLES: RuntimeEnvConfig = {
    flags: {
        connectTebutoMeetEnabled: false,
        connectZoomEnabled: true,
        connectMicrosoftTeamsEnabled: true,
        connectGoogleCalendarEnabled: true,
        connectOutlookEnabled: true,
        optionalClientDataEnabled: false,
        secureMessagesEnabled: false
    },
    payPal: {
        clientId: ''
    }
}

// Functions

export function getBooleanEnvVariable(name: string): boolean | undefined {
    const value = process.env[name]
    return value ? value === 'true' : undefined
}

export function getEnvVariablesWithDefaults(env: LoadedRuntimeEnvConfig): RuntimeEnvConfig {
    return {
        flags: {
            connectTebutoMeetEnabled:
                env.flags.connectTebutoMeetEnabled ?? DEFAULT_ENV_VARIABLES.flags.connectTebutoMeetEnabled,
            connectZoomEnabled: env.flags.connectZoomEnabled ?? DEFAULT_ENV_VARIABLES.flags.connectZoomEnabled,
            connectMicrosoftTeamsEnabled:
                env.flags.connectMicrosoftTeamsEnabled ?? DEFAULT_ENV_VARIABLES.flags.connectMicrosoftTeamsEnabled,
            connectGoogleCalendarEnabled:
                env.flags.connectGoogleCalendarEnabled ?? DEFAULT_ENV_VARIABLES.flags.connectGoogleCalendarEnabled,
            connectOutlookEnabled: env.flags.connectOutlookEnabled ?? DEFAULT_ENV_VARIABLES.flags.connectOutlookEnabled,
            optionalClientDataEnabled:
                env.flags.optionalClientDataEnabled ?? DEFAULT_ENV_VARIABLES.flags.optionalClientDataEnabled,
            secureMessagesEnabled: env.flags.secureMessagesEnabled ?? DEFAULT_ENV_VARIABLES.flags.secureMessagesEnabled
        },
        payPal: {
            clientId: env.payPal?.clientId ?? DEFAULT_ENV_VARIABLES.payPal?.clientId ?? ''
        }
    }
}
